import { render, staticRenderFns } from "./ControlPersonalPage.vue?vue&type=template&id=3e2ac51a"
import script from "./ControlPersonalPage.js?vue&type=script&lang=js&external"
export * from "./ControlPersonalPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports